import type { z } from "zod";

export const downloadFile = (url: string, fileName?: string): void => {
  const link = document.createElement("a");
  link.href = url;
  if (fileName) {
    link.setAttribute("download", fileName);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Delay the revocation of the URL to ensure the download starts
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 1000);
};

export const downloadCSV = (csv: string, fileName: string): void => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  downloadFile(url, fileName);
};

export const validateValues = <T extends z.ZodTypeAny>(
  values: Record<string, unknown>,
  schema: T
): z.infer<T> => {
  const result = schema.safeParse(values);
  if (!result.success) {
    const formattedErrors = Object.entries(result.error.flatten().fieldErrors)
      .map(([field, errors]) => `${field}: ${errors?.join(", ")}`)
      .join("\n");
    throw new Error(["Form validation failed!", formattedErrors].join("\n"));
  }
  return result.data;
};
